import { Routes } from '@angular/router';
import { PremyopiaDashboardComponent } from './premyopia-dashboard/premyopia-dashboard.component';
import { LoadingComponent } from './loading/loading.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { PlaceholderComponent } from './placeholder/placeholder.component';

export const routes: Routes = [
  { path: '', redirectTo: '/placeholder', pathMatch: 'full' },
  { path: 'placeholder', component: PlaceholderComponent },
  { path: 'loading', component: LoadingComponent },
  { path: 'premyopia-dashboard', component: PremyopiaDashboardComponent },
  { path: 'dashboard/:id', component: DashboardComponent },
];
